// extracted by mini-css-extract-plugin
export var container = "_6k-0";
export var infoButton = "_6k-1";
export var label = "_6k-3";
export var labelExpanded = "_6k-4";
export var price = "_6k-5";
export var priceExpanded = "_6k-6";
export var title = "_6k-2";